const STORAGE_KEY = "kz-recently-viewed-v1";
const MAX_PRODUCTS = 4;
const EXPIRY_DAYS = 7;

let currentProductSaved = false;

const getData = () => {
  try {
    const data = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    const now = Date.now();
    const expiry = 1000 * 60 * 60 * 24 * EXPIRY_DAYS;

    return data.filter(
      (product) =>
        product && product.handle && now - product.savedAt < expiry,
    );
  } catch {
    return [];
  }
};

const saveData = (data) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  } catch (error) {
    console.warn("Error saving recently viewed products", error);
  }
};

class RecentlyViewed extends HTMLElement {
  connectedCallback() {
    const dataNode = this.querySelector("[data-current-product-data]");
    const template = document.getElementById("psykhe-product-card");
    if (!dataNode || !template) return;

    let currentProductData;
    try {
      currentProductData = JSON.parse(dataNode.textContent);
    } catch {
      return;
    }
    currentProductData.savedAt = Date.now();

    const data = getData();

    if (typeof window.psykhe?.renderCard === "function") {
      this.render(data, currentProductData.handle, template);
    } else {
      document.addEventListener("DOMContentLoaded", () =>
        this.render(data, currentProductData.handle, template),
      );
    }

    data.unshift(currentProductData);

    const deduped = data
      .filter(
        ({ handle }, i, items) =>
          items.findIndex((item) => handle === item.handle) === i,
      )
      .slice(0, MAX_PRODUCTS + 1);

    if (!currentProductSaved) {
      saveData(deduped);
      currentProductSaved = true;
    }
  }

  render(data, currentHandle, template) {
    if (typeof window.psykhe?.renderCard !== "function") return;

    const productsToDisplay = data
      .filter((item) => item.handle !== currentHandle)
      .slice(0, MAX_PRODUCTS);

    if (!productsToDisplay.length) return;

    const grid = this.querySelector("[data-recently-viewed-grid]");
    if (!grid) return;

    const fragment = document.createDocumentFragment();
    productsToDisplay.forEach((item) => {
      fragment.appendChild(window.psykhe.renderCard(template, item));
    });

    grid.replaceChildren(fragment);
    this.classList.remove("hide");

    grid.dispatchEvent(
      new CustomEvent("psykhe:recommendations-rendered", {
        bubbles: true,
        detail: { type: "recently-viewed", count: productsToDisplay.length },
      }),
    );
  }
}

if (!customElements.get("recently-viewed")) {
  customElements.define("recently-viewed", RecentlyViewed);
}
